module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', [_c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('h2', [_vm._v("Create new document requirement")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Select entity"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity),
      expression: "entity"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.entity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options), function(value) {
    return (_vm.options.length) ? _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))]) : _vm._e()
  }), 0)]), (_vm.entity === 'VehicleCategory') ? _c('selectize-category', {
    on: {
      "optionSelected": _vm.entitySelected
    }
  }) : _vm._e(), (_vm.entity === 'Plan') ? _c('selectize-plan', {
    on: {
      "optionSelected": _vm.entitySelected
    }
  }) : _vm._e(), (_vm.entity === 'ClientType') ? _c('selectize-client-type', {
    on: {
      "optionSelected": _vm.entitySelected
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Document type"), _c('SelectizeDocumentType', {
    attrs: {
      "max-items": 1
    },
    on: {
      "optionSelected": _vm.documentTypeSelected
    }
  })], 1), _c('label', [_vm._v("Document group"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.document_group),
      expression: "body.document_group"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.document_group)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "document_group", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row columns text-center"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save Document Type")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b8649cb!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CreateDocumentRequirementButtonModal.vue
// module id = 2324
// module chunks = 1